import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Publish from "@material-ui/icons/Publish";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: "10px",
      float: "right"
    },
    input: {
      display: "none"
    }
  })
);

interface UploadButtonProps {
  accept?: string;
  type?: string;
  multiple?: boolean;
  onSelected: (e: any) => void;
}

export default function UploadButton(props: UploadButtonProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        accept={props.accept || ".csv"}
        className={classes.input}
        id="contained-button-file"
        multiple={props.multiple || false}
        onChange={props.onSelected}
        type="file"
      />
      <label htmlFor="contained-button-file">
        <Button color="primary" component="span" variant="contained">
          <Publish />
        </Button>
      </label>
    </div>
  );
}
